import { lazy } from "react";

const JuniorList = lazy(() => import("../Component/Junior/JuniorList"));
const ExJuniorList = lazy(() => import("../Component/Junior/Exjunior"));
const JuniorLeadsListDownline = lazy(() =>
  import("../Component/Junior/JuniorLeadsListDownline")
);
const JuniorLeadsList = lazy(() => import("../Component/Junior/JuniorLeadsList"));

const juniorRoutes = [
  { path: "/junior-list", element: <JuniorList />, protected: true },
  { path: "/former-Junior-list", element: <ExJuniorList />, protected: true },
  {
    path: "/junior-leads-list-downline/:id",
    element: <JuniorLeadsListDownline />,
    protected: true,
  },
  { path: "/junior-leads-list", element: <JuniorLeadsList />, protected: true },
];

export default juniorRoutes;
